<div class="display">
    <ng-content></ng-content>
</div>